import React, { useState, useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import { Icon } from "@iconify/react/dist/iconify.js";
import toast from "react-hot-toast";
import { getCategoryApi, createCategoryApi, updateCategoryApi, deleteCategoryApi, ImageUrl } from "../../helper/apiHelper";

const CategoryManagement = () => {
    const [categories, setCategories] = useState([]);
    const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
    const [newCategory, setNewCategory] = useState({ categoryName: '', categoryImage: null, categoryImagePreview: '', id: '' });
    const [isEditing, setIsEditing] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isPageLoading, setIsPageLoading] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [categoryToDelete, setCategoryToDelete] = useState(null);

    // Fetch categories on mount
    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            setIsPageLoading(true);
            const response = await getCategoryApi();
            setCategories(response.data || []);
        } catch (error) {
            toast.error(error || "Failed to fetch categories");
        } finally {
            setIsPageLoading(false);
        }
    };

    const handleCreateOrUpdateCategory = async () => {
        const { categoryName, categoryImage, id } = newCategory;

        if (!categoryName) {
            toast.error("Please enter category name");
            return;
        }

        if (!isEditing && !categoryImage) {
            toast.error("Please select category image");
            return;
        }

        try {
            setIsLoading(true);
            const formData = new FormData();
            formData.append('categoryName', categoryName);

            if (categoryImage) {
                formData.append('categoryImage', categoryImage);
            }

            if (isEditing) {
                await updateCategoryApi(formData, id);
                toast.success("Category updated successfully!");
            } else {
                await createCategoryApi(formData);
                toast.success("Category created successfully!");
            }

            setShowAddCategoryModal(false);
            setNewCategory({ categoryName: '', categoryImage: null, categoryImagePreview: '', id: '' });
            setIsEditing(false);
            fetchCategories(); // Refresh the list
        } catch (error) {
            toast.error(error || "Action failed");
        } finally {
            setIsLoading(false);
        }
    };

    const handleCategoryChange = (e) => {
        const { name, value } = e.target;
        setNewCategory((prev) => ({ ...prev, [name]: value }));
    };

    const handleEditClick = (item) => {
        setIsEditing(true);
        setShowAddCategoryModal(true);
        setNewCategory({
            categoryName: item.categoryName,
            categoryImage: null,
            categoryImagePreview: `${ImageUrl}/${item.categoryImage}`,
            id: item.id,
        });
    }

    const handleDeleteClick = (item) => {
        setCategoryToDelete(item);
        setShowDeleteModal(true);
    }

    const confirmDelete = async () => {
        if (!categoryToDelete) return;

        try {
            setIsLoading(true);
            await deleteCategoryApi(categoryToDelete.id);
            toast.success("Category deleted successfully");
            setShowDeleteModal(false);
            setCategoryToDelete(null);
            fetchCategories(); // Refresh the list
        } catch (error) {
            toast.error(error || "Failed to delete category");
        } finally {
            setIsLoading(false);
        }
    }

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };


    const filteredBooking = categories?.filter((item) => {
        const search = searchTerm?.toLowerCase();

        return Object.entries(item)
            .filter(([key]) =>
                ["categoryName"].includes(key)
            )
            .some(([_, value]) =>
                String(value)?.toLowerCase().includes(search)
            );
    });


    const [currentPage, setCurrentPage] = useState(1);

    const [itemsPerPage] = useState(10);
    const totalItems = categories?.length || 0;
    const itemsPerPageSafe = itemsPerPage || 1;
    const totalPages = Math.ceil(totalItems / itemsPerPageSafe);
    const startIdx = (currentPage - 1) * itemsPerPage;
    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    console.log("ImageUrl", ImageUrl)

    return (
        <MasterLayout>
            <Breadcrumb title="Category Management" />

            <div className="col-lg-12">
                <div className="card">
                    <div className="card-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "8px" }}>
                        {/* <h5 className="card-title mb-0">Guard Management</h5> */}
                        <form className="navbar-search d-flex align-items-center gap-2">
                            <input
                                type="text"
                                className="bg-base h-40-px w-auto form-control"
                                name="search"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <Icon icon="ion:search-outline" className="icon" />
                        </form>

                        <button
                            type="button"
                            className="btn btn-primary-600 radius-8 px-20 py-11"
                            onClick={() => {
                                setIsEditing(false); // Exit edit mode
                                setNewCategory({ categoryName: '', categoryImage: null, categoryImagePreview: '', id: '' });
                                setShowAddCategoryModal(true); // Open modal
                            }}
                        >
                            + Create Category
                        </button>

                    </div>
                    <div className="card-body">
                        {isPageLoading ? (
                            <div className="text-center py-40">
                                <span className="spinner-border spinner-border-lg text-primary-600" role="status" />
                                <p className="text-muted mt-3">Loading categories...</p>
                            </div>
                        ) : (
                            <>
                                <div className="table-responsive">
                                    {filteredBooking?.length === 0 ? (
                                        <div className="text-center py-40 text-muted fw-medium">No category found.</div>
                                    ) : (
                                        <table className="table basic-border-table mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Date</th>
                                                    <th>Category Name</th>
                                                    <th>Category Image</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredBooking?.slice(startIdx, startIdx + itemsPerPage)?.map((items, index) => (



                                                    <tr key={index}>
                                                        <td>{formatDate(items.createdAt)}</td>
                                                        <td>{items.categoryName}</td>
                                                        <td>
                                                            <img
                                                                src={`${ImageUrl}/${items.categoryImage}`}
                                                                alt={items.categoryName}
                                                                className="w-64-px h-64-px radius-8 object-fit-cover"
                                                            />
                                                        </td>
                                                        <td className="text-start">
                                                            <div className="d-flex align-items-start gap-10 justify-content-start">
                                                                <button
                                                                    type="button"
                                                                    className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                                    onClick={() => handleEditClick(items)}
                                                                >
                                                                    <Icon icon="lucide:edit" className="menu-icon" />
                                                                </button>

                                                                <button
                                                                    type="button"
                                                                    onClick={() => handleDeleteClick(items)}
                                                                    className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                                >
                                                                    <Icon icon="fluent:delete-24-regular" className="menu-icon" />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                </div>

                                {filteredBooking?.length > itemsPerPage &&


                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24 mb-10">
                                        <span>
                                            Showing {startIdx + 1} to{" "}
                                            {Math.min(startIdx + itemsPerPage, filteredBooking?.length)} of{" "}
                                            {filteredBooking?.length} entries
                                        </span>
                                        <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                                            <li className="page-item">
                                                <button
                                                    className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                                                    onClick={() => goToPage(currentPage - 1)}
                                                    disabled={currentPage === 1}
                                                >
                                                    <Icon icon="ep:d-arrow-left" className="text-xl" />
                                                </button>
                                            </li>

                                            {[...Array(totalPages)].map((_, index) => (
                                                <li className="page-item" key={index}>
                                                    <button
                                                        className={`page-link ${currentPage === index + 1
                                                            ? "bg-primary-600 text-white"
                                                            : "bg-primary-50 text-secondary-light"
                                                            } fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px`}
                                                        onClick={() => goToPage(index + 1)}
                                                    >
                                                        {index + 1}
                                                    </button>
                                                </li>
                                            ))}

                                            <li className="page-item">
                                                <button
                                                    className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                                                    onClick={() => goToPage(currentPage + 1)}
                                                    disabled={currentPage === totalPages}
                                                >
                                                    <Icon icon="ep:d-arrow-right" className="text-xl" />
                                                </button>
                                            </li>
                                        </ul>
                                    </div>}
                            </>
                        )}

                    </div>
                </div>
                {/* card end */}
            </div>


            {showAddCategoryModal && (
                <>
                    <div className="modal fade show" style={{ display: 'block' }}>
                        <div
                            className="modal-dialog modal-md modal-dialog-centered"
                            style={{ zIndex: 11122 }}
                        >
                            <div className="modal-content radius-16 bg-base">
                                <div className="modal-header py-16 px-24 border-bottom">
                                    <h1 className="modal-title fs-5">  {isEditing ? "Update Category" : "Add Category"}</h1>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowAddCategoryModal(false)}
                                    />
                                </div>

                                <div className="modal-body p-24">
                                    <form className="row g-3">
                                        <div className="col-12">
                                            <label className="form-label fw-semibold">Category Name</label>
                                            <input
                                                type="text"
                                                name="categoryName"
                                                className="form-control"
                                                value={newCategory.categoryName}
                                                onChange={handleCategoryChange}
                                                placeholder="Enter Category Name"
                                            />
                                        </div>
                                        <div className="col-12">
                                            <label className="form-label fw-semibold">Category Image <span className="text-muted fs-12" style={{ fontWeight: "normal" }} >(Recommended Size: 198px x 259px)</span></label>
                                            <input
                                                type="file"
                                                name="categoryImage"
                                                className="form-control"
                                                accept="image/*"
                                                onChange={(e) => {
                                                    const file = e.target.files[0];
                                                    if (!file) return;

                                                    const reader = new FileReader();
                                                    const img = new Image();

                                                    reader.onload = (event) => {
                                                        img.src = event.target.result;
                                                    };

                                                    img.onload = () => {
                                                        const TARGET_WIDTH = 198;
                                                        const TARGET_HEIGHT = 259;

                                                        const canvas = document.createElement("canvas");
                                                        canvas.width = TARGET_WIDTH;
                                                        canvas.height = TARGET_HEIGHT;

                                                        const ctx = canvas.getContext("2d");

                                                        // 🔑 Clear canvas to preserve transparency
                                                        ctx.clearRect(0, 0, TARGET_WIDTH, TARGET_HEIGHT);

                                                        // Maintain aspect ratio & center crop
                                                        const scale = Math.max(
                                                            TARGET_WIDTH / img.width,
                                                            TARGET_HEIGHT / img.height
                                                        );

                                                        const x = (TARGET_WIDTH - img.width * scale) / 2;
                                                        const y = (TARGET_HEIGHT - img.height * scale) / 2;

                                                        ctx.drawImage(
                                                            img,
                                                            x,
                                                            y,
                                                            img.width * scale,
                                                            img.height * scale
                                                        );

                                                        // 🔑 Export as PNG (keeps transparency)
                                                        canvas.toBlob(
                                                            (blob) => {
                                                                const resizedFile = new File(
                                                                    [blob],
                                                                    file.name.replace(/\.(jpg|jpeg)$/i, '.png'),
                                                                    { type: "image/png", lastModified: Date.now() }
                                                                );

                                                                const previewUrl = URL.createObjectURL(resizedFile);

                                                                setNewCategory(prev => ({
                                                                    ...prev,
                                                                    categoryImage: resizedFile,
                                                                    categoryImagePreview: previewUrl
                                                                }));
                                                            },
                                                            "image/png"
                                                        );
                                                    };

                                                    reader.readAsDataURL(file);
                                                }}

                                            />

                                            {newCategory.categoryImagePreview && (
                                                <div className="mt-3">
                                                    <div
                                                        style={{
                                                            width: "198px",
                                                            height: "259px",
                                                            borderRadius: "8px",
                                                            overflow: "hidden",
                                                            // border: "1px solid #e5e7eb"
                                                        }}
                                                    >
                                                        <img
                                                            src={newCategory.categoryImagePreview}
                                                            alt="Preview"
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                objectFit: "cover"
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            )}

                                        </div>

                                        <div className="d-flex align-items-center justify-content-end gap-3 mt-24">
                                            <button
                                                type="button"
                                                className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-24 py-10 radius-8"
                                                onClick={() => {
                                                    setShowAddCategoryModal(false);
                                                    setNewCategory({ categoryName: '', categoryImage: null, categoryImagePreview: '', id: '' });
                                                    setIsEditing(false);
                                                }}
                                            >
                                                Cancel
                                            </button>

                                            <button
                                                type="button"
                                                className="btn btn-primary border border-primary-600 text-md px-32 py-10 radius-8 d-flex align-items-center gap-2"
                                                onClick={handleCreateOrUpdateCategory}
                                                disabled={isLoading}
                                            >
                                                {isLoading ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm" role="status" />
                                                        Saving...
                                                    </>
                                                ) : (
                                                    isEditing ? 'Update' : 'Save'
                                                )}
                                            </button>

                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        {/* Modal backdrop */}
                        <div
                            className="modal-backdrop fade show"
                            style={{ zIndex: 1040 }}
                        />
                    </div>
                </>
            )}

            {/* Delete Confirmation Modal */}
            {showDeleteModal && (
                <>
                    <div className="modal fade show" style={{ display: 'block' }}>
                        <div
                            className="modal-dialog modal-md modal-dialog-centered"
                            style={{ zIndex: 11122 }}
                        >
                            <div className="modal-content radius-16 bg-base">
                                <div className="modal-header py-16 px-24 border-bottom">
                                    <h1 className="modal-title fs-5">Confirm Delete</h1>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => {
                                            setShowDeleteModal(false);
                                            setCategoryToDelete(null);
                                        }}
                                    />
                                </div>

                                <div className="modal-body p-24">
                                    <p className="text-secondary-light mb-0">
                                        Are you sure you want to delete the category <strong>"{categoryToDelete?.categoryName}"</strong>? This action cannot be undone.
                                    </p>
                                </div>

                                <div className="modal-footer py-16 px-24 border-top">
                                    <button
                                        type="button"
                                        className="border border-neutral-300 bg-hover-neutral-200 text-secondary-light text-md px-24 py-10 radius-8"
                                        onClick={() => {
                                            setShowDeleteModal(false);
                                            setCategoryToDelete(null);
                                        }}
                                        disabled={isLoading}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-danger border border-danger-600 text-md px-32 py-10 radius-8 d-flex align-items-center gap-2"
                                        onClick={confirmDelete}
                                        disabled={isLoading}
                                    >
                                        {isLoading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm" role="status" />
                                                Deleting...
                                            </>
                                        ) : (
                                            'Delete'
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Modal backdrop */}
                        <div
                            className="modal-backdrop fade show"
                            style={{ zIndex: 1040 }}
                        />
                    </div>
                </>
            )}

        </MasterLayout>
    );
};

export default CategoryManagement;
